/**
 * PersonalRecordTypes Collection.  Defines a collection of the different PersonalRecordTypes.
 */
import Backbone from 'backbone';

import PersonalRecordType from 'models/prs/PersonalRecordType';
import { filterTypes, PersonalRecordTabTypes } from 'utils/PersonalRecordsUtil';

export const Types = {
    RUN_1K: 'pr.label.1k.run',
    RUN_5K: 'pr.label.5k.run',
    RUN_10K: 'pr.label.10k.run',
    RUN_HALF_MARATHON: 'pr.label.half.marathon',
    RUN_MARATHON: 'pr.label.full.marathon',
    RUN_FARTHEST: 'pr.label.farthest.run',
    RUN_1Mile: 'pr.label.1mile.run',
    CYCLE_FARTHEST: 'pr.label.farthest.cycle',
    CYCLE_MAX_ELEV: 'pr.label.max.elev',
    CYCLE_MAX_POWER: 'pr.label.max.power',
    CYCLE_40K: 'pr.label.40k.cycle',
    STEPS_BEST_DAY: 'pr.label.steps.best.day',
    STEPS_BEST_WEEK: 'pr.label.steps.best.week',
    STEPS_BEST_MONTH: 'pr.label.steps.best.month',
    STEPS_LONGEST_STREAK: 'pr.label.steps.longest.streak',
    STEPS_CURRENT_STREAK: 'pr.label.steps.current.streak',
    SWIM_LONGEST: 'pr.label.longest.poolswim',
    SWIM_100M: 'pr.label.100m.poolswim',
    SWIM_400M: 'pr.label.400m.poolswim',
    SWIM_750M: 'pr.label.750m.poolswim',
    SWIM_1000M: 'pr.label.1000m.poolswim',
    SWIM_1500M: 'pr.label.1500m.poolswim',
    SWIM_100YD: 'pr.label.100yd.poolswim',
    SWIM_500YD: 'pr.label.500yd.poolswim',
    SWIM_1000YD: 'pr.label.1000yd.poolswim',
    SWIM_1650YD: 'pr.label.1650yd.poolswim',
    STRENGTH_TRAINING_BARBELL_BENCH_PRESS: 'pr.label.max.rep.weight.bench_press',
    STRENGTH_TRAINING_BARBELL_OVERHEAD_PRESS: 'pr.label.max.rep.weight.overhead_press',
    STRENGTH_TRAINING_BARBELL_BACK_SQUAT: 'pr.label.max.rep.weight.squat',
    STRENGTH_TRAINING_BARBELL_DEADLIFT: 'pr.label.max.rep.weight.deadlift',
    STRENGTH_TRAINING_BARBELL_ROW: 'pr.label.max.rep.weight.row',
    PUSHES_BEST_DAY: 'pr.label.pushes.best.day',
    PUSHES_BEST_WEEK: 'pr.label.pushes.best.week',
    PUSHES_BEST_MONTH: 'pr.label.pushes.best.month',
    PUSHES_LONGEST_STREAK: 'pr.label.pushes.longest.streak',
    PUSHES_CURRENT_STREAK: 'pr.label.pushes.current.streak',
    WHEELCHAIR_RUN_1K: 'pr.label.1k.wheelchair.run',
    WHEELCHAIR_RUN_5K: 'pr.label.5k.wheelchair.run',
    WHEELCHAIR_RUN_10K: 'pr.label.10k.wheelchair.run',
    WHEELCHAIR_RUN_HALF_MARATHON: 'pr.label.half.marathon.wheelchair.run',
    WHEELCHAIR_RUN_MARATHON: 'pr.label.full.marathon.wheelchair.run',
    WHEELCHAIR_RUN_FARTHEST: 'pr.label.longest.wheelchair.push',
    WHEELCHAIR_RUN_1Mile: 'pr.label.1mile.wheelchair.run'
};

export const GetSortOrder = function(key) {
    var aSortOrder = 99;
    switch (key) {
        case Types.RUN_1K:
            aSortOrder = 0;
            break;
        case Types.RUN_1Mile:
            aSortOrder = 1;
            break;
        case Types.RUN_5K:
            aSortOrder = 2;
            break;
        case Types.RUN_10K:
            aSortOrder = 3;
            break;
        case Types.RUN_HALF_MARATHON:
            aSortOrder = 4;
            break;
        case Types.RUN_MARATHON:
            aSortOrder = 5;
            break;
        case Types.RUN_FARTHEST:
            aSortOrder = 6;
            break;

        case Types.CYCLE_40K:
            aSortOrder = 10;
            break;
        case Types.CYCLE_MAX_ELEV:
            aSortOrder = 11;
            break;
        case Types.CYCLE_MAX_POWER:
            aSortOrder = 12;
            break;
        case Types.CYCLE_FARTHEST:
            aSortOrder = 13;
            break;

        case Types.STEPS_BEST_DAY:
            aSortOrder = 14;
            break;
        case Types.STEPS_BEST_WEEK:
            aSortOrder = 15;
            break;
        case Types.STEPS_BEST_MONTH:
            aSortOrder = 16;
            break;
        case Types.STEPS_LONGEST_STREAK:
            aSortOrder = 17;
            break;
        case Types.STEPS_CURRENT_STREAK:
            aSortOrder = 18;
            break;

        case Types.SWIM_100M:
            aSortOrder = 20;
            break;
        case Types.SWIM_100YD:
            aSortOrder = 21;
            break;
        case Types.SWIM_400M:
            aSortOrder = 22;
            break;
        case Types.SWIM_500YD:
            aSortOrder = 23;
            break;
        case Types.SWIM_750M:
            aSortOrder = 24;
            break;
        case Types.SWIM_1000M:
            aSortOrder = 25;
            break;
        case Types.SWIM_1000YD:
            aSortOrder = 26;
            break;
        case Types.SWIM_1500M:
            aSortOrder = 27;
            break;
        case Types.SWIM_1650YD:
            aSortOrder = 28;
            break;
        case Types.SWIM_LONGEST:
            aSortOrder = 29;
            break;

        case Types.STRENGTH_TRAINING_BARBELL_BACK_SQUAT:
            aSortOrder = 30;
            break;
        case Types.STRENGTH_TRAINING_BARBELL_BENCH_PRESS:
            aSortOrder = 31;
            break;
        case Types.STRENGTH_TRAINING_BARBELL_DEADLIFT:
            aSortOrder = 32;
            break;
        case Types.STRENGTH_TRAINING_BARBELL_ROW:
            aSortOrder = 33;
            break;
        case Types.STRENGTH_TRAINING_BARBELL_OVERHEAD_PRESS:
            aSortOrder = 34;
            break;
    }

    return aSortOrder;
};

var PersonalRecordTypes = Backbone.Collection.extend({
    model: PersonalRecordType,

    url: function() {
        var displayNameText = this.displayName || '';
        return '/personalrecord-service/personalrecordtype/prtypes/' + displayNameText;
    },
    backend: 'gcapi',
    initialize: function(models, args) {
        this.displayName = args.displayName;
    },

    parse: function(response) {
        if (!response) return [];

        const personalRecordsTypesKeys = Object.keys(PersonalRecordTabTypes);
        const filteredPersonalRecordsTypes = personalRecordsTypesKeys.map((key) => filterTypes(key, response));

        return filteredPersonalRecordsTypes.flat();
    },

    //There isn't anything returned in the Personal Record Type that can reliably
    //be used in a sort to render the Customize List dynamically in the correct
    //order.  This method will manually assign a temporary sort order for each
    //PR Type so the collection can be sorted.

    comparator: function(a, b) {
        var aSortOrder = GetSortOrder(a.get('key'));

        var bSortOrder = GetSortOrder(b.get('key'));

        if (aSortOrder < bSortOrder) {
            return -1;
        } else if (aSortOrder > bSortOrder) {
            return 1;
        } else {
            return 0;
        }
    },

    hasWalkingPRTypes: function() {
        return !!this.find((prType) => prType.get('sport') === 'WALKING');
    }
});

PersonalRecordTypes.Types = Types;
PersonalRecordTypes.GetSortOrder = GetSortOrder;

export default PersonalRecordTypes;
